<template>
    <div>LOGBOOK LIQUIDATING OFFICER</div>
</template>